import React, { useState } from "react";
import styles from "./WorldsSection.scss";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

import WorldsArt from "../../../../assets/images/worlds-art.png";
import EntranceWorld from "../../../../assets/images/EntranceWorld.png";
import SideStreetWorld from "../../../../assets/images/SideStreetWorld.png";
import MeetingRoomWorld from "../../../../assets/images/MeetingRoomWorld.png";
import AudioVisualRoomWorld from "../../../../assets/images/AudioVisualRoomWorld.png";
import EventRoomWorld from "../../../../assets/images/EventRoomWorld.png";
import MediaCenterWorld from "../../../../assets/images/MediaCenterWorld.png";

// 動画のインポート（WebM/MP4）
import EntranceWorldWebM from "../../../../assets/images/MCUEntrance.webm";
import EntranceWorldMP4 from "../../../../assets/images/MCUEntrance.mp4";
import SideStreetWorldWebM from "../../../../assets/images/MCUYokotyou.webm";
import SideStreetWorldMP4 from "../../../../assets/images/MCUYokotyou.mp4";
import MeetingWorldWebM from "../../../../assets/images/MCUMeetingRoom.webm";
import MeetingWorldMP4 from "../../../../assets/images/MCUMeetingRoom.mp4";
import AudioVisualRoomWorldWebM from "../../../../assets/images/MCUTheater.webm";
import AudioVisualRoomWorldMP4 from "../../../../assets/images/MCUTheater.mp4";
import EventRoomWorldWebM from "../../../../assets/images/MCUEventroom.webm";
import EventRoomWorldMP4 from "../../../../assets/images/MCUEventroom.mp4";
import MediaCenterWorldWebM from "../../../../assets/images/MCUmediacenter.webm";
import MediaCenterWorldMP4 from "../../../../assets/images/MCUmediacenter.mp4";

export function WorldsSection() {
  // スクロールアニメーション
  const [holeRef, holeVisible] = useScrollAnimation({ threshold: 0.3 });
  const [cardsRef, cardsVisible] = useScrollAnimation({ threshold: 0.1 });

  // ホバー/タップ中のカードIDを管理
  const [activeCardId, setActiveCardId] = useState(null);

  const worlds = [
    {
      id: "entrance",
      name: "エントランスワールド",
      description:
        "MetaCampUsにおけるスポーン地点。操作ガイドや全体マップを通して、初めての人でも安心して探索を始められます。出会いや案内の起点となる場所。",
      image: EntranceWorld,
      videoWebM: EntranceWorldWebM,
      videoMP4: EntranceWorldMP4
    },
    {
      id: "event",
      name: "イベントワールド",
      description:
        "講義やプレゼンテーション、ディスカッションなどを行う大空間。研究発表や起業ピッチ、トークセッションなども開くことが可能です。",
      image: EventRoomWorld,
      videoWebM: EventRoomWorldWebM,
      videoMP4: EventRoomWorldMP4
    },
    {
      id: "media",
      name: "メディアセンターワールド",
      description:
        "学びの資料やアントレプレナー教育といったコンテンツが集まる知の拠点。各カリキュラムや講師室へもアクセスできます。",
      image: MediaCenterWorld,
      videoWebM: MediaCenterWorldWebM,
      videoMP4: MediaCenterWorldMP4
    },
    {
      id: "sidestreet",
      name: "横丁ワールド",
      description: "偶発的な出会いや雑談が生まれる地下の横丁空間。自由に集い、語り合える。MetaCampUsの縁側的な空間。",
      image: SideStreetWorld,
      videoWebM: SideStreetWorldWebM,
      videoMP4: SideStreetWorldMP4
    },
    {
      id: "meeting",
      name: "ミーティングワールド",
      description:
        "チームや研究グループが集まるための空間。会議のほか、ゼミや勉強会などの様々な活動を行うことができます。",
      image: MeetingRoomWorld,
      videoWebM: MeetingWorldWebM,
      videoMP4: MeetingWorldMP4
    },
    {
      id: "av",
      name: "視聴覚室ワールド",
      description: "映像やプレゼンテーションを共有できる空間。アイデアを視覚的に伝えられます。",
      image: AudioVisualRoomWorld,
      videoWebM: AudioVisualRoomWorldWebM,
      videoMP4: AudioVisualRoomWorldMP4
    }
  ];

  return (
    <section id="worlds" className={styles.worldsSection}>
      {/* アート画像 - セクション基準で配置 */}
      <img
        src={WorldsArt}
        alt=""
        className={`${styles.holeArt} ${holeVisible ? styles.artAnimate : styles.artHidden}`}
      />
      {/* 不定形の緑のくぼみ穴 */}
      <div ref={holeRef} className={`${styles.holeContainer} ${holeVisible ? styles.holeAnimate : styles.holeHidden}`}>
        {/* アニメーションする穴 */}
        <svg className={styles.holeSvg} viewBox="-10 -10 120 120" preserveAspectRatio="none">
          <defs>
            <linearGradient id="worldsHoleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#C4E4D2" />
              <stop offset="50%" stopColor="#BEDBE4" />
              <stop offset="100%" stopColor="#C4E4D2" />
            </linearGradient>
            <filter id="worldsInnerShadow" x="-50%" y="-50%" width="200%" height="200%">
              <feFlood floodColor="black" floodOpacity="1" result="flood" />
              <feComposite in="flood" in2="SourceAlpha" operator="out" result="outside" />
              <feOffset in="outside" dx="3" dy="3" result="offsetShadow" />
              <feGaussianBlur in="offsetShadow" stdDeviation="4" result="blurShadow" />
              <feComposite in="blurShadow" in2="SourceAlpha" operator="in" result="innerShadow" />
              <feColorMatrix
                in="innerShadow"
                type="matrix"
                result="coloredShadow"
                values="0 0 0 0 0
                        0 0 0 0 0
                        0 0 0 0 0
                        0 0 0 0.5 0"
              />
              <feMerge>
                <feMergeNode in="SourceGraphic" />
                <feMergeNode in="coloredShadow" />
              </feMerge>
            </filter>
          </defs>
          <path fill="url(#worldsHoleGradient)" filter="url(#worldsInnerShadow)">
            <animate
              attributeName="d"
              dur="20s"
              repeatCount="indefinite"
              values="
                M 18 12 C 25 -2 42 -2 52 10 S 78 -2 90 18 S 108 48 92 72 S 108 112 82 128 S 48 138 32 112 S -2 122 2 68 S -8 28 18 12 Z;
                M 15 18 C 28 2 38 5 55 8 S 82 2 92 22 S 105 52 88 78 S 102 115 78 130 S 45 135 28 108 S 2 118 5 62 S -5 32 15 18 Z;
                M 20 8 C 32 -5 45 0 52 15 S 75 0 88 15 S 110 42 95 70 S 112 110 85 125 S 52 140 35 115 S -5 125 0 72 S -10 25 20 8 Z;
                M 18 12 C 25 -2 42 -2 52 10 S 78 -2 90 18 S 108 48 92 72 S 108 112 82 128 S 48 138 32 112 S -2 122 2 68 S -8 28 18 12 Z
              "
            />
          </path>
        </svg>
      </div>
      <div className={styles.worldsContainer}>
        <h2 className={styles.worldsTitle}>Worlds</h2>
        <p className={styles.worldsSubtitle}>
          {`MetaCampUsの世界\nそれは、想いが集い、学び、広がっていく場所。\n\nMetaCampUsには、目的や活動に合わせた複数のワールドがあります。\n学ぶ、創る、集う——。\nそれぞれの空間が、あなたの"やりたい"を動かす舞台になります。`}
        </p>
        <div ref={cardsRef} className={styles.worldsGrid}>
          {worlds.map((world, index) => {
            const isActive = activeCardId === world.id;

            return (
              <div
                key={world.id}
                className={`${styles.worldCard} ${cardsVisible ? styles.cardAnimate : styles.cardHidden}`}
                style={{ animationDelay: `${index * 0.1}s` }}
                onMouseEnter={() => setActiveCardId(world.id)}
                onMouseLeave={() => setActiveCardId(null)}
                onTouchStart={() => setActiveCardId(world.id)}
                onTouchEnd={() => setActiveCardId(null)}
              >
                <div className={styles.worldImageWrapper}>
                  {isActive && world.videoWebM ? (
                    <video
                      autoPlay
                      loop
                      muted
                      playsInline
                      className={styles.worldImage}
                    >
                      <source src={world.videoWebM} type="video/webm" />
                      <source src={world.videoMP4} type="video/mp4" />
                    </video>
                  ) : (
                    <img src={world.image} alt={world.name} className={styles.worldImage} />
                  )}
                </div>
                <div className={styles.worldContent}>
                  <h3 className={styles.worldName}>{world.name}</h3>
                  <p className={styles.worldDescription}>{world.description}</p>
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles.scrollIndicator}>スワイプ</div>
        <p className={styles.worldsFooter}>
          {`どのワールドにも、学びや創造の入り口があります。\nあなたの興味や想いに合わせて、自由に歩き、話し、アクションしてみてください。`}
        </p>
      </div>
    </section>
  );
}
